import React, { useContext, useEffect } from 'react'
import MonetizationPieChart from '../../../../components/Charts/CCSMonetizaation/PieChart'
import { ThemeContext } from '../../../../context'
import MultipleLineChart from '../../../../components/Charts/CCSMonetizaation/MiltipleLineChart'
import { MARKETING_ACTIVITY_COLORS } from '../../../../constants'
import { getSvtSubscriptionsPerMarket, getSvtSubscriptionsPerMarketTrendline } from '../../../../api/ccsMonetizationApi'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'

const MarketBreakdownTile = withRouter((props: RouteComponentProps) => {
  const { history } = props;
  const { theme } = useContext(ThemeContext)

  const { data: pieChartData, isFetching: pieChartIsFFetching, refetch: refetchPieChartData } = useQuery({
    queryKey: ["svtSubscriptionsPerMarketPieData", history.location.search],
    queryFn: getSvtSubscriptionsPerMarket,
    enabled: false,
  });

  const { data: trendChartData, isFetching: trendIsFetching, refetch: refetchTrendChartData } = useQuery({
    queryKey: ["svtSubscriptionsPerMarketTrendData", history.location.search],
    queryFn: getSvtSubscriptionsPerMarketTrendline,
    enabled: false,
  });

  useEffect(() => {
    refetchPieChartData()
    refetchTrendChartData()
  }, [history.location.search])

  return (
    <div className='breakdown-tile'>
      <div className='tile-header'>
        Market breakdown
      </div>
      <div className='tile-content'>
        <div className='chart-tile'>
          <div className='tile-header'>SVT Subscriptions Number per Market</div>
          <div className="tile-content">
            <MonetizationPieChart
              chartId='subscriptionNoPerMarketPieChart'
              data={pieChartData}
              valueField='value'
              categoryField='category'
              theme={theme}
              legendPosition='bottom'
              isLoading={pieChartIsFFetching}
            />
          </div>
        </div>
        <div className='chart-tile'>
          <div className='tile-header'> SVT Subscriptions Number Trendline per Market </div>
          <div className="tile-content">
            <MultipleLineChart
              chartId='subscriptionsPerMarketLineChart'
              data={trendChartData?.data ?? []}
              seriesList={trendChartData?.series ?? []}
              theme={theme}
              isLoading={trendIsFetching}
              seriesColors={MARKETING_ACTIVITY_COLORS}
              isPercentage={true}
            />
          </div>
        </div>
      </div>
    </div>
  )
})

export default MarketBreakdownTile